import { render, staticRenderFns } from "./NearList.vue?vue&type=template&id=9addbaf4"
import script from "./NearList.vue?vue&type=script&lang=js"
export * from "./NearList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports